import React from 'react';
import PropTypes from 'prop-types';

const RoundedImageView = ({ src , onClick , size , className , objectFit , alt }) => (<img src={src}
                                                              alt={alt}
                                                              onClick={onClick}
                                                              className={`img-fluid rounded-circle ${className}`}
                                                              style={{
                                                                  cursor: 'pointer',
                                                                  width: size,
                                                                  height: size,
                                                                  objectFit
                                                              }}/>);


RoundedImageView.propTypes = {
    src: PropTypes.string,
    onClick: PropTypes.func,
    size: PropTypes.number,
    className: PropTypes.string,
    objectFit: PropTypes.string,
    alt: PropTypes.string
};

RoundedImageView.defaultProps ={
  size: 32,
  objectFit: "cover",
  alt: "Profile image"
};

export default RoundedImageView;


// WEBPACK FOOTER //
// ./src/components/RoundedImageView/RoundedImageView.js